import axios from "axios";
import { API_URL, FOLDERPATH } from "../Constants/config";
import { toast } from "react-toastify";
import {
  VISUAL_DOCUMENT_LOADING, VISUAL_DOCUMENT_SUCCESS, VISUAL_DOCUMENT_FAILED,
  UPLOAD_FILE_LOADING,
  UPLOAD_FILE_SUCCESS,
  UPLOAD_FILE_FAILED,
  REMOVE_FILE_LOADING,
  REMOVE_FILE_FAILED,
  REMOVE_FILE_SUCCESS,
  SAVE_VISUAL_DATA_LOADING,
  SAVE_VISUAL_DATA_SUCCESS,
  SAVE_VISUAL_DATA_FAILED
  } from "../Constants/visualDocConstants";
 

export const getVisualDoc = (formData) => async (dispatch) => {
  try {

    dispatch({ type: VISUAL_DOCUMENT_LOADING });

    let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  

    formData.token = userLocalData.id;

    const requestData = formData;

    //return false;
    const headers = {
      "Content-Type": "application/json",
      "Username": "ibridge",
      "Password": "ibridge@2020",
    };

    //axios.defaults.baseURL = API_URL;

    const { data } = await axios.post(FOLDERPATH + "/CandidateApi/checkDetail", requestData, {
        headers,
     });
     
     console.log("sas",data);

     if (data.status === "success") {

    dispatch({
      type: VISUAL_DOCUMENT_SUCCESS,
      payload: data,
    });

  }else{

    // dispatch({
    //   type: AUTHORIZATION_FAILED,
    //   payload: data
    // });

    const msg = data.message;

    toast.dismiss();

    toast.error(msg, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    userLocalData.auth_complete = 1;

    console.log(userLocalData);

    localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
   // window.location.reload();

  }

  } catch (error) {
    dispatch({
      type: VISUAL_DOCUMENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });
  }
};





//import { handleApiError } from "../Helper/actionHelper";
//Something went wrong. Please try again.
const errorMsg = "Please select the Document type First";

export const getUploadFile =
  (record, file) =>
  async (dispatch) => {
    try {
      
      dispatch({ type: UPLOAD_FILE_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      record.token=userLocalData.id;

      console.log(record);

      let formData = new FormData();
      Object.keys(record).map((k) => {
        formData.set(k, record[k]);
      });
      for (let i = 0; i < record.check_documents.length; i++) {
        formData.append(`${"check_documents"}[${i}]`, record.check_documents[i]);
      }



      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/uploadFiles",
        formData,
        {
          headers,
        }
      );
      dispatch({
        type: UPLOAD_FILE_SUCCESS,
        payload: data,
      });
      if (data) {
        const msg = "Uploaded Successfully";
        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        alert("Invalid file");
      }
      return data;

     // handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: UPLOAD_FILE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });

     // handleApiError(error);
    }
  };

export const removeFile =
  (record,val) =>
  async (dispatch) => {
    try {
      dispatch({ type: REMOVE_FILE_LOADING });

      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      const requestData = {
        token: userLocalData.id,
        ...record,
      };

      // let formData = new FormData();

      // formData.append("token", userLocalData.id);
      // formData.append("mode", mode);
      // if (file.lengh > 1) {
      //   for (let i = 0; i < file.length; i++) {
      //     formData.append(`${mode}[${i}]`, file[i]);
      //   }
      // } else {
      //   formData.append(mode, file);
      // }

      // // in case of multiple file upload
      // // formData.append(mode, file);

      // // in case of multiple file upload

      // for (let i = 0; i < file.length; i++) {
      //   formData.append(`${mode}[${i}]`, file[i]);
      // }

      // // in case of multiple file upload
      // // formData.append(mode, file);

      // if (mode === "check_documents") {
      //   formData.append("chkid", record.caseCheckId);
      //   formData.append("docid", record.docId);
      // }

      // console.log(formData);

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/removeFiles",
        requestData,
        {
          headers,
        }
      );

      await dispatch({
        type: REMOVE_FILE_SUCCESS,
        payload: data,
      });
     
      const msg = "Removed Successfully";
      if(val!=false){
      toast.success(msg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
      return data;
    //  handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: REMOVE_FILE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
     // handleApiError(error);
    }
  };

  export const saveVisualData = (formData) => async (dispatch) => {
    try {
  
      dispatch({ type: SAVE_VISUAL_DATA_LOADING });
  
      let userLocalData = JSON.parse(localStorage.getItem('userVerificationCandidate'));  
  
      formData.token = userLocalData.id;
  
      const requestData = formData;
  
      //return false;
      const headers = {
        "Content-Type": "application/json",
        "Username": "ibridge",
        "Password": "ibridge@2020",
      };
  
      //axios.defaults.baseURL = API_URL;
  
      const { data } = await axios.post(FOLDERPATH + "/CandidateApi/saveCheckDetails", requestData, {
          headers,
       });
       
       console.log("sas",data);
  
       if (data.status === "success") {
  
      dispatch({
        type: SAVE_VISUAL_DATA_SUCCESS,
        payload: data,
      });
  
    }else{
  
      // dispatch({
      //   type: AUTHORIZATION_FAILED,
      //   payload: data
      // });
  
      const msg = data.message;
  
      toast.dismiss();
  
      toast.error(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
  
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      userLocalData.auth_complete = 1;
  
      console.log(userLocalData);
  
      localStorage.setItem("userVerificationCandidate", JSON.stringify(userLocalData));
     // window.location.reload();
  
    }
  
    } catch (error) {
      dispatch({
        type: SAVE_VISUAL_DATA_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });
    }
  };


  export const deleteSaveVisualData = () => (dispatch) => {
    dispatch({
      type: SAVE_VISUAL_DATA_SUCCESS,
      payload: [],
    });
  };

  export const deleteGetVisualData = () => (dispatch) => {
    dispatch({
      type: VISUAL_DOCUMENT_SUCCESS,
      payload: [],
    });
  };